import React, { useState } from 'react';
import {
  Box, Paper, Typography, TextField, Button, Alert, Divider, Chip, Stack,
} from '@mui/material';
import { LockReset, Person } from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';
import api from '../../services/api';

const ProfilePage = () => {
  const { user } = useAuth();

  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword]         = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading]                 = useState(false);
  const [success, setSuccess]                 = useState('');
  const [error, setError]                     = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess('');
    setError('');

    if (newPassword !== confirmPassword) {
      return setError('הסיסמאות החדשות אינן תואמות');
    }
    if (newPassword.length < 6) {
      return setError('הסיסמה החדשה חייבת להכיל לפחות 6 תווים');
    }

    setLoading(true);
    try {
      const { data } = await api.post('/auth/change-password', {
        currentPassword,
        newPassword,
      });
      setSuccess(data.message || 'הסיסמה עודכנה בהצלחה');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (err) {
      setError(err.response?.data?.error || 'שגיאה בעדכון הסיסמה');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box maxWidth={500} mx="auto" mt={4}>
      <Paper sx={{ p: 4 }}>
        {/* פרטי משתמש */}
        <Stack direction="row" alignItems="center" gap={1} mb={2}>
          <Person color="primary" />
          <Typography variant="h6">פרופיל משתמש</Typography>
        </Stack>

        <Typography variant="body1" mb={1}>
          <strong>שם משתמש:</strong> {user?.username}
        </Typography>

        <Stack direction="row" gap={1} flexWrap="wrap" mb={1}>
          <Typography variant="body2" color="text.secondary">תפקידים:</Typography>
          {user?.roles?.map((r) => (
            <Chip key={r} label={r} size="small" color="primary" variant="outlined" />
          ))}
        </Stack>

        <Divider sx={{ my: 3 }} />

        {/* שינוי סיסמה */}
        <Stack direction="row" alignItems="center" gap={1} mb={2}>
          <LockReset color="primary" />
          <Typography variant="h6">שינוי סיסמה</Typography>
        </Stack>

        {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
        {error   && <Alert severity="error"   sx={{ mb: 2 }}>{error}</Alert>}

        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            label="סיסמה נוכחית"
            type="password"
            fullWidth
            required
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            sx={{ mb: 2 }}
          />
          <TextField
            label="סיסמה חדשה"
            type="password"
            fullWidth
            required
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            sx={{ mb: 2 }}
          />
          <TextField
            label="אימות סיסמה חדשה"
            type="password"
            fullWidth
            required
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            sx={{ mb: 3 }}
          />
          <Button
            type="submit"
            variant="contained"
            fullWidth
            disabled={loading}
          >
            {loading ? 'מעדכן...' : 'עדכן סיסמה'}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default ProfilePage;
